import { defineQuery } from 'next-sanity';

import { FRAGMENTS } from './fragments';

export const INDUSTRY_PAGE_QUERY = defineQuery(`
  *[_type == "industry" && slug.current == $slug][0]{
    _id,
    name,
    "slug": slug.current,
    metaData { title, description, indexable },
    heading {
      title,
      description,
      buttonText,
      buttonLink ${FRAGMENTS.link},
      backgroundImage ${FRAGMENTS.imageWithMetadata},
      backgroundOverlay,
      backgroundPosition ${FRAGMENTS.responsiveValue},
      containerPadding ${FRAGMENTS.responsivePadding},
      contentGap ${FRAGMENTS.responsiveValue},
      contentMaxWidth ${FRAGMENTS.responsiveValue},
      titleMaxWidth ${FRAGMENTS.responsiveValue},
      descriptionStyles {
        mobile { textSize, textColor, maxWidth },
        tablet { textSize, textColor, maxWidth },
        laptop { textSize, textColor, maxWidth },
        desktop { textSize, textColor, maxWidth }
      },
      buttonMargin {
        mobile { marginTop, marginBottom },
        tablet { marginTop, marginBottom },
        laptop { marginTop, marginBottom },
        desktop { marginTop, marginBottom }
      },
      buttonPadding ${FRAGMENTS.responsivePadding},
      buttonStyles {
        textColor,
        mobile { textSize, height },
        tablet { textSize, height },
        laptop { textSize, height },
        desktop { textSize, height }
      },
      buttonVariant
    },
    sections[] {
      _type,
      _key,
      _type == "poweredBySection" => {
        label,
        logo ${FRAGMENTS.imageWithMetadata},
        description,
        backgroundColor,
        containerPadding ${FRAGMENTS.responsivePadding},
        contentMaxWidth ${FRAGMENTS.responsiveValue}
      },
      _type == "featuresAccordionSection" => {
        heading,
        accordion {
          items[] {
            title,
            description,
            image ${FRAGMENTS.imageWithMetadata},
            icon ${FRAGMENTS.imageWithMetadata}
          },
          gap ${FRAGMENTS.responsiveValue}
        },
        backgroundColor,
        containerPadding ${FRAGMENTS.responsivePadding},
        contentMaxWidth ${FRAGMENTS.responsiveValue},
        contentGap ${FRAGMENTS.responsiveValue},
        headingMaxWidth ${FRAGMENTS.responsiveValue}
      },
      _type == "ctvPartnersSection" => {
        title,
        text,
        logoSlider {
          logos[] {
            logo ${FRAGMENTS.imageWithMetadata},
            type
          }
        },
        backgroundColor,
        containerPadding ${FRAGMENTS.responsivePadding},
        contentMaxWidth ${FRAGMENTS.responsiveValue},
        contentGap ${FRAGMENTS.responsiveValue},
        textGap ${FRAGMENTS.responsiveValue}
      },
      _type == "featuresCardSection" => {
        heading,
        cardGrid {
          cards[] {
            title,
            text,
            image ${FRAGMENTS.imageWithMetadata},
            imageMobile ${FRAGMENTS.imageWithMetadata},
            style,
            imagePosition { laptop, desktop },
            maxWidth,
            link { href, text, target, rel },
            rowGap
          },
          gap ${FRAGMENTS.responsiveValue}
        },
        backgroundColor,
        containerPadding ${FRAGMENTS.responsivePadding},
        contentMaxWidth ${FRAGMENTS.responsiveValue},
        contentGap ${FRAGMENTS.responsiveValue},
        headingMaxWidth ${FRAGMENTS.responsiveValue}
      },
      _type == "featuresHorizontalCardSection" => {
        heading,
        subtitle,
        cardList {
          cards[] {
            title,
            text,
            image ${FRAGMENTS.imageWithMetadata},
            button {
              text,
              link ${FRAGMENTS.link}
            },
            objectPositionLeft
          },
          gap ${FRAGMENTS.responsiveValue}
        },
        backgroundColor,
        containerPadding ${FRAGMENTS.responsivePadding},
        contentMaxWidth ${FRAGMENTS.responsiveValue},
        contentGap ${FRAGMENTS.responsiveValue},
        headingMaxWidth ${FRAGMENTS.responsiveValue},
        headingSubtitleGap ${FRAGMENTS.responsiveValue}
      },
      _type == "contactSection" => {
        title,
        text,
        buttonText,
        buttonLink ${FRAGMENTS.link},
        backgroundImage ${FRAGMENTS.imageWithMetadata},
        imageWidth,
        imageHeight,
        outerContainerPadding ${FRAGMENTS.responsivePadding},
        outerContainerBackgroundColor,
        innerContainerPadding ${FRAGMENTS.responsivePadding},
        innerContainerMaxWidth ${FRAGMENTS.responsiveValue},
        contentGap ${FRAGMENTS.responsiveValue},
        textGap ${FRAGMENTS.responsiveValue},
        textContainerMaxWidth ${FRAGMENTS.responsiveValue},
        titleMaxWidth ${FRAGMENTS.responsiveValue},
        textMaxWidth ${FRAGMENTS.responsiveValue},
        titlePadding ${FRAGMENTS.responsivePadding},
        imagePosition {
          mobile { top, right, maxWidth },
          tablet { top, right, maxWidth },
          laptop { top, right, maxWidth },
          desktop { top, right, maxWidth }
        }
      },
      _type == "testimonialSection" => {
        heading,
        testimonials[] {
          name,
          title,
          text,
          avatar ${FRAGMENTS.imageWithMetadata},
          logo ${FRAGMENTS.imageWithMetadata},
          video,
          thumbnail ${FRAGMENTS.imageWithMetadata}
        },
        partnerLogos[] ${FRAGMENTS.imageWithMetadata},
        backgroundColor,
        containerPadding ${FRAGMENTS.responsivePadding},
        contentMaxWidth ${FRAGMENTS.responsiveValue}
      }
    },
    latestResourcesSection {
      header,
      heading,
      featuredResources[]-> ${FRAGMENTS.resourceWithMetadata},
      theme,
      containerPadding ${FRAGMENTS.responsivePadding},
      contentMaxWidth ${FRAGMENTS.responsiveValue},
      headerHeadingGap ${FRAGMENTS.responsiveValue},
      headerHeadingPadding ${FRAGMENTS.responsivePadding},
      gridGap {
        horizontal ${FRAGMENTS.responsiveValue},
        vertical ${FRAGMENTS.responsiveValue}
      },
      gridColumns ${FRAGMENTS.responsiveValue}
    },
    faqSection {
      heading,
      description,
      accordion {
        items[] { title, content, isOpenByDefault },
        gap ${FRAGMENTS.responsiveValue}
      },
      backgroundColor,
      containerPadding ${FRAGMENTS.responsivePadding},
      contentMaxWidth ${FRAGMENTS.responsiveValue},
      contentGap ${FRAGMENTS.responsiveValue},
      headingDescriptionGap ${FRAGMENTS.responsiveValue},
      headingDescriptionMaxWidth ${FRAGMENTS.responsiveValue},
      accordionMaxWidth ${FRAGMENTS.responsiveValue}
    }
  }
`);
